<template>
  <div>
    <v-row align="center">
      <!-- Product Images -->
      <v-col cols="12" sm="3" md="2" class="d-flex justify-center justify-sm-start">
        <div class="image-stack">
          <template v-for="(item, idx) in storage.items.slice(0, 2)">
            <template v-if="item.productId.photos && item.productId.photos.length > 0">
              <v-img
                :key="idx"
                :src="baseURL + 'u/' + item.productId.photos[0]"
                :alt="item.productname"
                height="100"
                width="100"
                contain
                class="product-image rounded-lg"
                :class="{ 'stacked-image': idx > 0 }"
              >
                <template v-slot:placeholder>
                  <v-row class="fill-height ma-0" align="center" justify="center">
                    <v-progress-circular indeterminate color="#3EA56E" size="20"></v-progress-circular>
                  </v-row>
                </template>
              </v-img>
            </template>
            <template v-else>
              <v-img
                :key="idx"
                :src="require('../../../assets/noimg.png')"
                :alt="item.productname"
                height="100"
                width="100"
                contain
                class="product-image rounded-lg"
                :class="{ 'stacked-image': idx > 0 }"
              >
              </v-img>
            </template>
          </template>
          <div v-if="storage.items.length > 2" class="more-items-count">
            +{{ storage.items.length - 2 }}
          </div>
        </div>
      </v-col>

      <!-- Order Details -->
      <v-col cols="12" sm="6" md="7">
        <div class="d-flex flex-column h-full">
          <div class="d-flex align-center mb-1">
            <h3 class="product-name mr-2">
              {{ storage.items[0].productname }}
              <span v-if="storage.items.length > 1" class="more-suffix">
                & {{ storage.items.length - 1 }} more
              </span>
            </h3>
            <v-chip
              v-if="storage.orderid.orderStatus"
              x-small
              label
              :color="getStatusColor(storage.orderid.orderStatus)"
              class="status-chip white--text"
            >
              {{ storage.orderid.orderStatus }}
            </v-chip>
          </div>

          <div class="order-meta mt-1">
            <div class="meta-item">
              <v-icon size="14" color="#64748b" class="mr-1">mdi-credit-card-outline</v-icon>
              <span>{{ storage.orderid.paymentType }}</span>
            </div>
            <div class="meta-item">
              <v-icon size="14" color="#64748b" class="mr-1">mdi-calendar-clock</v-icon>
              <span>Ordered: {{ formatDate(storage.orderid.init_date) }}</span>
            </div>
            <div class="meta-item">
              <v-icon size="14" color="#64748b" class="mr-1">mdi-identifier</v-icon>
              <span>ID: {{ storage.orderid.orderID }}</span>
            </div>
          </div>
        </div>
      </v-col>

      <!-- Action Area -->
      <v-col cols="12" sm="3" md="3" class="text-right">
        <div class="price-container mb-3">
          <span class="price-label">Total Amount</span>
          <div class="price-value">Rs. {{ storage.orderid.orderTotal }}</div>
        </div>
        <v-btn
          depressed
          rounded
          block
          color="#3EA56E"
          dark
          class="details-btn"
          :to="'/Orders/' + storage.orderid._id"
        >
          View Details
        </v-btn>
      </v-col>
    </v-row>
  </div>
</template>
<script>
export default {
  props: ["storage"],
  data() {
    return {
    };
  },
  beforeMount() {},
  methods: {
    formatDate(item) {
      var dt = new Date(item);
      var day = dt.getDate();
      var year = dt.getFullYear();
      dt = dt.toString();
      var strTime = day + " " + dt.slice(4, 7) + " " + year;
      return strTime;
    },
    getStatusColor(status) {
      switch (status?.toLowerCase()) {
        case "delivered":
          return "#10B981";
        case "pending":
          return "#F59E0B";
        case "cancelled":
          return "#EF4444";
        case "shipped":
          return "#3B82F6";
        default:
          return "#64748B";
      }
    },
  },
};
</script>

<style scoped>
.image-stack {
  position: relative;
  width: 100px;
  height: 100px;
}

.product-image {
  border: 1px solid #f1f5f9;
  background: white;
}

.stacked-image {
  position: absolute;
  top: 8px;
  left: 8px;
  z-index: -1;
  opacity: 0.6;
}

.more-items-count {
  position: absolute;
  bottom: 0;
  right: 0;
  background: rgba(0, 0, 0, 0.6);
  color: white;
  padding: 2px 6px;
  border-radius: 4px;
  font-size: 10px;
  font-weight: bold;
}

.product-name {
  font-family: "poppinssemibold", sans-serif;
  font-size: 16px;
  color: #1e293b;
  margin: 0;
}

.more-suffix {
  font-family: "poppinsmedium", sans-serif;
  color: #64748b;
  font-size: 14px;
}

.status-chip {
  font-family: "poppinssemibold", sans-serif;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.order-meta {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.meta-item {
  display: flex;
  align-center: center;
  font-family: "poppinsregular", sans-serif;
  font-size: 13px;
  color: #64748b;
}

.price-container {
  display: flex;
  flex-direction: column;
}

.price-label {
  font-family: "poppinsmedium", sans-serif;
  font-size: 12px;
  color: #94a3b8;
  text-transform: uppercase;
}

.price-value {
  font-family: "poppinssemibold", sans-serif;
  font-size: 18px;
  color: #1e293b;
}

.details-btn {
  font-family: "poppinsmedium", sans-serif;
  text-transform: none;
  letter-spacing: 0.3px;
}

@media (max-width: 600px) {
  .price-container {
    align-items: flex-start;
    margin-top: 12px;
  }
  .product-name {
    font-size: 15px;
  }
}
</style>